import {
  Component,
  Input,
  ViewChild,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
  AfterViewInit,
} from '@angular/core';
import { IonContent } from '@ionic/angular';
import { BrowseHierarchyViewModel } from '@usf/ngrx-product/lib/models/browse-hierarchy-state.model';
import { MerchandisingProductViewModel } from '@shared/models/merchandising-product-view.model';
import { PdpLnkSrc } from '@shared/constants/pdp-lnksrc.enum';
import { QuantityUpdate } from '@shared/models/quantity-update';
import { Observable } from 'rxjs';
import { PlatformService } from '@panamax/app-state';
import { TOP_SELLERS, RECENTLY_VIEWED } from '@shared/constants/home-constants';
import { ZipCodeBannerComponent } from '../zip-code-banner/zip-code-banner.component';
import { ProductDetailViewModel } from '@product-detail/models/product-detail-view-model';

@Component({
  selector: 'app-browse-products',
  templateUrl: './browse-products.component.html',
  styleUrls: ['./browse-products.component.scss'],
})
export class BrowseProductsComponent implements OnDestroy, AfterViewInit {
  @Input() browseHierarchyViewModel: BrowseHierarchyViewModel;
  @Input() isGuestUser: boolean;
  @Input() searchPath: string;
  @Input() browseScoopParams: any;
  @Input() scoopImageUrl: string;
  @Input() directImageUrl: string;
  @Input() directId: number;
  @Input() isDirectEligible: boolean;
  @Input() directQueryParams: any;
  @Input() neweandsParams: any;
  @Input() topSellerProducts$: Observable<MerchandisingProductViewModel[]>;
  @Input() recentlyViewedProducts$: Observable<MerchandisingProductViewModel[]>;
  @Input() platformService: PlatformService;
  @Input() newTopSellers: ProductDetailViewModel[];
  @Input() isTopSellersLoading: boolean;

  @Output() quantityUpdateEmitter = new EventEmitter<{
    quantityUpdate: QuantityUpdate;
    index: number;
  }>();
  @Output() recentlyViewedQuantityUpdateEmitter = new EventEmitter<{
    quantityUpdate: QuantityUpdate;
    index: number;
  }>();
  @Output() productClickEmitter = new EventEmitter<ProductDetailViewModel>();

  @ViewChild(IonContent) content: IonContent;

  TOP_SELLER_FEATURE_NAME = TOP_SELLERS;
  RECENTLY_VIEWED_FEATURE_NAME = RECENTLY_VIEWED;

  topSellerLnkSrc = PdpLnkSrc.topSellers;
  recentlyViewedLnkSrc = PdpLnkSrc.recentlyViewed;
  @ViewChild(ZipCodeBannerComponent) zipCodeBanner: ZipCodeBannerComponent;

  constructor() {}

  ngAfterViewInit() {
    if (this.isGuestUser) {
      this.zipCodeBanner?.onInit();
    }
  }

  ngOnDestroy() {
    if (this.isGuestUser) {
      this.zipCodeBanner?.onDestroy();
    }
  }

  onTopSellerQuantityUpdate(event: {
    quantityUpdate: QuantityUpdate;
    index: number;
  }) {
    this.quantityUpdateEmitter.emit(event);
  }

  onProductCardClick(product: ProductDetailViewModel) {
    this.productClickEmitter.emit(product);
  }

  onRecentlyViewedQuantityUpdate(event: {
    quantityUpdate: QuantityUpdate;
    index: number;
  }) {
    this.recentlyViewedQuantityUpdateEmitter.emit(event);
  }
}
